import {NotificationCategory} from './notificationCategory';
import {NotificationType} from './notificationType';
import {EnumCardLayoutHeaderIcon} from '../layout/enumCardLayoutHeaderIcon';

export class Notification {
  public icon: string;

  constructor(public type: NotificationType,
              public category: NotificationCategory,
              public titel: string,
              public text: string,
              public closeIcon: boolean = true,
              public duration: number
              ) {
    this.icon = EnumCardLayoutHeaderIcon['CardLayout' + this.category];
  }
}
